<template>
  <div
    v-if="contents && selectedCarouselItem !== null"
    class="screensaver"
    style="width: 100%;height:100%;
      background-repeat: no-repeat;
      background-size: cover;
    "
    :style="{
      backgroundImage: backgroundImage ? `url('${backgroundImage}')` : null,
    }"
  >
    <v-carousel 
      v-model="selectedCarouselItem"
      :cycle="false"
      :show-arrows="false" 
      hide-delimiters
      height="100%"
    >
      <template
        v-for="(item, i) in contents"
      >
        <div v-if="item.type === 'Clock'" :key="i">
          <custom-text :item="item.content" />
        </div>
        <v-carousel-item
          v-else
          :key="i"
          v-html="item.content"
        />
      </template>
      <!--v-carousel-item
        v-for="(item, i) in contents"
        :key="i"
        v-html="item.content"
      /-->
    </v-carousel>

  </div>
</template>
<script>
import CustomText from './CustomText'
export default {
  name: 'CustomCarousel',
  components: {
    CustomText,
  },
  props: {
    zone: {
      type: String,
      default: null,
    },
    contents: {
      type: Array,
      default: null,
    },
    onEnd: {
      type: Function,
      default: null,
    },
    backgroundImage: {
      type: String,
      default: null,
    },
    lmu: {
      type: String,
      default: null,
    },
  },
  data: () => ({
    timer: null,
    selectedCarouselItem: null,
    animationTime: '50s', // only messages
  }),
  computed: {
    log () {
      return false // this.zone === 'PARRILLA' ? true : false
    },
  },
  watch: {
    lmu () {
      this.selectedCarouselItem = 0
      this.handleInterval()
    },
  },
  mounted () {
    this.selectedCarouselItem = 0
    this.handleInterval()
  },
  methods: {
    handleInterval () {
      const content = this.contents[this.selectedCarouselItem]
      const duration = content ? content.duration * 1000 : 0
if (this.log) console.log(this.zone, content ? content.type : null, content ? content : null, duration)
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.handleChangeContent()
      }, duration)
    },
    handleChangeContent () {
      const before = this.selectedCarouselItem
      this.selectedCarouselItem = this.selectedCarouselItem < this.contents.length-1 ? this.selectedCarouselItem + 1 : 0
      const after = this.selectedCarouselItem
if (this.log) console.log('jhm', this.isLast, `[${this.contents.length}]`, before, '-', after)
      this.handleInterval () 
      if (this.selectedCarouselItem === 0 && this.onEnd) {
if (this.log) console.log('jhm end')
        this.onEnd()
      }
    },
  },
}
</script>
<style>
.message-preview {
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
}
.p-preview {
    display: inline-block;
    padding-left: 100%;
    animation: move linear infinite;
}
@keyframes move {
    0%   { transform: translate(0, 0); }
    100% { transform: translate(-100%, 0); }
}
</style>

